// Written in this round about way for babel-transform-imports
import Route from 'react-router/es/Route';

export default Route;


//////////////////
// WEBPACK FOOTER
// /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/react-router-dom/es/Route.js
// module id = 21
// module chunks = 1 2 3 4 5